module.exports = __webpack_public_path__ + "static/staff_jonathan-e4ca15d81d33a57f8b1e705029fe6c50.png";